module.exports = __webpack_public_path__ + "img/share-popup-bag.5546daa6.png";